var Queensland = "ควีนส์แลนด์";
var Tasmania = "แทสเมเนีย";
var Victoria = "วิกตอเรีย";
var AUStates = {
	"Australian Capital Territory": "ออสเตรเลียนแคพิทอลเทร์ริทอรี",
	"New South Wales": "นิวเซาท์เวลส์",
	"Northern Territory": "นอร์เทิร์นเทร์ริทอรี",
	Queensland: Queensland,
	"South Australia": "เซาท์ออสเตรเลีย",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "เวสเทิร์นออสเตรเลีย"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
